import React, { Component } from 'react'
import './EditMinutes.css'
import { motion } from 'framer-motion'
import { backdropTransition, popupTransition, transitionDuration } from '../../../../../../../../../Util/PageTransitions'
import Checkbox from '../../../../../../../../../Util/Checkbox/Checkbox'

export default class EditMinutes extends Component {
    constructor() {
        super()
        this.state = {
            minutes: [false, false, false, false],
            hour: 0
        }
    }

    componentDidMount() {
        if (typeof this.props.currentTime === 'boolean') {
            if (this.props.currentTime) {
                this.setState({ minutes: [true, true, true, true] })
            } else {
                this.setState({ minutes: [false, false, false, false] })
            }
        } else {
            this.setState({ minutes: this.props.currentTime })
        }
        this.getHoursHandler()
    }

    updateMinutesHandler = (cell) => {
        let { minutes } = this.state
        minutes[cell] = !minutes[cell]
        this.setState({ minutes })
    }

    getTitleHandler = () => {
        let { columnSelected, rowSelected, times } = this.props
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        return `${days[columnSelected]} - ${times[rowSelected]} `
    }

    getHoursHandler = () => {
        let { rowSelected } = this.props
        if (rowSelected === 0) return 12
        else if (rowSelected <= 12) {
            this.setState({ hour: rowSelected })
        } else {
            this.setState({ hour: rowSelected - 12 })
        }
    }

    render() {
        return (
            <motion.div className='editMinutesPageContainer' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
                <div className='editMinutesBackdrop' onMouseDown={this.props.closeContainer} />
                <motion.div className='editMinutesContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                    <div className='editMinutesHeaderContainer'>
                        <h1 className='editMinutesHeaderText'>{this.getTitleHandler()}</h1>
                        <button className='modifyHoursHeaderCloseButton' onMouseDown={this.props.closeContainer}>&#10005;</button>
                    </div>
                    <div className='editMinutesOptionsContainer'>
                        <div className={this.state.minutes[0] ? 'editMinutesOptionSelected' : 'editMinutesOption'} onMouseDown={() => this.updateMinutesHandler(0)}>
                            <Checkbox checked={this.state.minutes[0]} />
                            <p className={this.state.minutes[0] ? 'editMinutesOptionTextSelected' : 'editMinutesOptionText'}>{this.state.hour === 0 ? 12 : this.state.hour}:00 - {this.state.hour === 0 ? 12 : this.state.hour}:15{this.props.rowSelected < 12 ? 'AM' : 'PM'}</p>
                        </div>
                        <div className={this.state.minutes[1] ? 'editMinutesOptionSelected' : 'editMinutesOption'} onMouseDown={() => this.updateMinutesHandler(1)}>
                            <Checkbox checked={this.state.minutes[1]} />
                            <p className={this.state.minutes[1] ? 'editMinutesOptionTextSelected' : 'editMinutesOptionText'}>{this.state.hour === 0 ? 12 : this.state.hour}:15 - {this.state.hour === 0 ? 12 : this.state.hour}:30{this.props.rowSelected < 12 ? 'AM' : 'PM'}</p>
                        </div>
                        <div className={this.state.minutes[2] ? 'editMinutesOptionSelected' : 'editMinutesOption'} onMouseDown={() => this.updateMinutesHandler(2)}>
                            <Checkbox checked={this.state.minutes[2]} />
                            <p className={this.state.minutes[2] ? 'editMinutesOptionTextSelected' : 'editMinutesOptionText'}>{this.state.hour === 0 ? 12 : this.state.hour}:30 - {this.state.hour === 0 ? 12 : this.state.hour}:45{this.props.rowSelected < 12 ? 'AM' : 'PM'}</p>
                        </div>
                        <div className={this.state.minutes[3] ? 'editMinutesOptionSelected' : 'editMinutesOption'} onMouseDown={() => this.updateMinutesHandler(3)} style={{ borderBottom: 'none' }}>
                            <Checkbox checked={this.state.minutes[3]} />
                            <p className={this.state.minutes[3] ? 'editMinutesOptionTextSelected' : 'editMinutesOptionText'}>{this.state.hour === 0 ? 12 : this.state.hour}:45 - {this.state.hour === 0 ? 1 : this.state.hour === 12 ? 1 : this.state.hour + 1}:00 {this.state.hour + 1 === 12 && this.props.rowSelected !== 23 ? 'PM' : this.state.hour === 0 ? 'AM' : this.props.rowSelected + 1 < 12 ? 'AM' : this.props.rowSelected + 1 === 24 ? 'AM' : 'PM'}</p>
                        </div>
                    </div>
                    <div className='editMinutesOptionsButtonContainer'>
                        <button className='editMinutesOptionsButton secondaryButton' onMouseDown={this.props.closeContainer} style={{ justifySelf: 'end' }}>Cancel</button>
                        <button className='editMinutesOptionsButton primaryButton' onMouseDown={() => this.props.saveMinutesHandler(this.state.minutes)}>Save Changes</button>
                    </div>
                </motion.div>
            </motion.div>
        )
    }
}
